import { compose, withStateHandlers } from 'recompose'

const enhance = compose(
  withStateHandlers(({ isExpanded }) => ({ isExpanded }), {
    handleToggle: ({ isExpanded }) => () => ({ isExpanded: !isExpanded }),
  }),
)

export default enhance
